export default __webpack_public_path__ + "static/media/6_saddle.359b8372.png";